module.exports = __webpack_public_path__ + "img/ps44f83amrafbmt7ilf5ogb1d28m59gg2f70ee82de-9c84-486a-ac0c-537d1228630b.7937c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ps44f83amrafbmt7ilf5ogb1d28m59gg2f70ee82de-9c84-486a-ac0c-537d1228630b.png
// module id = YYTD
// module chunks = 1